<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>{{ id ? "编辑资源" : "新增资源" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content" style="padding-top: 15px">
      <el-form ref="goodsForm" :model="goodsForm" :rules="rules" label-width="120px">
        <el-form-item label="资源名称：" prop="itemName">
          <el-input type="textarea" :rows="5" maxlength="300" show-word-limit v-model="goodsForm.itemName"
            placeholder="请输入资源名称" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="imgText" prop="itemImage">
          <el-upload ref="upload" :multiple="true" action="/YmUpload_image" list-type="picture-card"
            :on-remove="handleRemoveImg" :before-upload="beforeImgUplod" :http-request="handleSuccessImg"
            :file-list="itemImage" accept=".JPG,.png,.GIF" :limit="1" :class="{
              hide: goodsForm.itemImage,
            }">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="资源视频：" prop="itemLink" v-if="type == 'video'">
          <el-upload ref="upload" :multiple="true" action="/YmUpload_videoFile" :on-remove="handleRemoveVideo"
            :http-request="handleSuccessVideo" :file-list="itemLink" accept="video/*" :limit="1" :class="{
              hide: goodsForm.itemLink,
            }">
            <el-button v-show="!goodsForm.itemLink" size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item label="资源多图：" prop="itemImages" v-else-if="type == 'image'">
          <el-upload ref="upload" :multiple="true" action="/YmUpload_image" list-type="picture-card"
            :on-remove="handleRemoveImg1" :before-upload="beforeImgUplod" :http-request="handleSuccessImg1"
            :file-list="imageList" accept=".JPG,.png,.GIF">
            <i class=" el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button :loading="isUpload" type="danger" @click="submit()">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { uploadImg, addBdmItem, uploadVideo } from "../api/index";
export default {
  data() {
    return {
      type: '',
      imgText: '',
      
      id: "",
      itemImage: [],
      imageList: [],
      itemLink: [],
      isUpload: false,
      goodsForm: {
        itemName: "",
        itemImage: "",
        itemLink: "",
        itemImages: [],
      },
      rules: {
        itemName: [
          {
            required: true,
            message: "请输入资源名称",
            trigger: "blur",
          },
        ],
        itemImage: [
          {
            required: true,
            message: "请上传资源图片",
            trigger: "change",
          },
        ],
        itemLink: [
          {
            required: true,
            message: "请上传资源视频",
            trigger: "change",
          },
        ],
        itemImages: [
          {
            required: true,
            message: "请上传资源多图",
            trigger: "change",
          },
        ]
      },
    };
  },
  watch: {},
  mounted() {
    this.type = this.$route.query.type;
    this.imgText = this.type == 'image' ? '资源首图：' : '资源图片：'
  },
  methods: {
    handleRemoveImg() {
      this.goodsForm.itemImage = "";
    },
    handleSuccessImg(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      this.isUpload = true;
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.goodsForm.itemImage = res.data.url;
          this.isUpload = false;
        }
      });
    },

    handleRemoveVideo() {
      this.goodsForm.itemLink = "";
    },

    handleRemoveImg1(e) {
      this.goodsForm.itemImages = this.goodsForm.itemImages.filter(item => item.name != e.name)
    },
    handleSuccessImg1(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      this.isUpload = true;
      uploadImg(imgUploadForm).then((result) => {
        if (result.code == 1) {
          this.goodsForm.itemImages.push({ name: res.file.name, url: result.data.url });
          this.isUpload = false;
        }
      });
    },
    handleSuccessVideo(res) {
      let videoUploadForm = new FormData();
      videoUploadForm.append("file", res.file);
      videoUploadForm.append("fileContentType", res.file.type);
      videoUploadForm.append("fileFileName", res.file.name);
      videoUploadForm.append("isCompre", 1);
      videoUploadForm.append("isCutImage", 1);
      this.isUpload = true;
      uploadVideo(videoUploadForm).then((res) => {
        if (res.code == 1) {
          this.goodsForm.itemLink = res.data.url;
          this.isUpload = false;
        }
      });
    },
    beforeImgUplod(file) {
      let types = ["image/jpeg", "image/jpg", "image/png"];
      const isJPG = types.includes(file.type);
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG 格式!");
      }
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isJPG && isLt3M;
    },
    submit(cb = "") {
      // return
      this.$refs.goodsForm.validate((valid) => {
        if (valid) {
          const httpData = {
            activityId: this.$route.query.activityId,
            itemName: this.goodsForm.itemName,
            itemImage: this.goodsForm.itemImage,
          }
          if (this.type == 'video') {
            httpData.itemLink = this.goodsForm.itemLink;
            httpData.itemType = 20;
          } else if (this.type == 'image') {
            let tempArr = [];
            this.goodsForm.itemImages.forEach(item => {
              tempArr.push(item.url);
            })
            httpData.itemImages = tempArr.join();
            httpData.itemType = 70;
            httpData.itemLink = "1";
          }

          addBdmItem(httpData).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: `${this.id ? "修改成功" : "新增成功"}`,
                type: "success",
                duration: 1000,
              });
              if (cb) {
                cb(res);
              } else {
                this.$router.push(
                  `/marketing/bdmItem?activityId=${this.$route.query.activityId}`
                );
              }
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "warning",
                duration: 1000,
              });
            }
          });

        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.tab-content {
  .el-form {
    width: 50%;
  }
}

.popup-container {
  padding: 20px;

  &.center {
    text-align: center;
  }

  p {
    font-size: 18px;
    text-align: center;
    line-height: 25px;
  }
}

.form-inline-content {
  border-bottom: 1px solid #d8d8d8;
  min-height: 40px;
  padding-bottom: 24px;

  &.flex {
    display: flex;

    .inside-content+.inside-content {
      margin-left: 50px;
    }
  }

  .flex-row-start {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .inside-content {
    &.center {
      text-align: center;
    }

    .flex-column-around {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding-left: 60px;
      box-sizing: border-box;
    }

    .scan-code-img {
      display: inline-block;
      // width: 100px;
      height: 100px;
    }

    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }

    .el-input,
    .el-select {
      width: 300px;
      margin-right: 10px;
    }
  }
}

.flex-row-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.specification-header {
  width: 452px;
  height: 40px;
  background: #f8f8f8;
  padding: 0 10px;
  color: #606266;
  font-size: 12px;
}

.specification-body {
  width: 450px;
  height: auto;
  border: 1px solid #ececec;
  border-top: none;
  padding: 0 10px;
  line-height: 40px;
}

.width25 {
  width: 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  box-sizing: border-box;

  &:last-child {
    cursor: pointer;
  }
}

.dialog-selproducts {
  .content-page {
    .tab-content {
      padding: 0;

      .products-list {
        width: 100%;

        .list-title {
          display: flex;
          padding: 0 20px 0 0;
          line-height: 40px;
          background: #f8f8f8;

          .title {
            box-sizing: border-box;
            padding-left: 10px;
            flex: 1;
          }
        }

        .list-footer {
          .el-button {
            margin-left: 10px;
          }
        }
      }
    }
  }
}

.dialog-selgoods {
  .content-page {
    overflow: hidden;

    .bd {
      height: 100%;

      &.sort {
        height: 100%;
        overflow-y: scroll;

        .tab-header {
          background: #fffcf5;
          border-bottom-color: #f2e7b8;
        }

        .tab-content {
          .goods-list {
            width: 100%;
          }
        }
      }
    }

    .tab-header {
      .btn-group-one {
        .upload-xls {
          display: inline-block;
          margin: 0 15px;
        }
      }

      .btn-group-two {
        .el-checkbox {
          margin-right: 15px;
        }
      }
    }

    .tab-content {
      padding: 0;
      height: 500px;

      .goods-classify-list {
        width: 120px;
        min-width: 120px;
        height: 100%;
        background: #f8f8f8;
        font-size: 12px;
        overflow: auto;

        li {
          color: #666666;
          padding-left: 20px;
          padding: 15px 20px;
          line-height: 20px;
          border-bottom: 1px solid #eeeeee;
          cursor: pointer;
          width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &.active {
            background: #fff;
          }
        }
      }
    }

    .tab-footer {
      text-align: center;
      margin: 10px 0;

      .el-button {
        margin-left: 10px;
      }
    }

    .el-pagination {
      padding: 0;
    }

    .goods-list {
      width: calc(100% - 120px);
      min-width: calc(100% - 120px);
      box-sizing: border-box;

      .list-title {
        display: flex;
        padding: 0 20px 0 0;
        line-height: 40px;
        background: #f8f8f8;

        .title {
          box-sizing: border-box;
          padding-left: 10px;
          flex: 1;

          &:first-of-type {
            min-width: 400px;
            max-width: 400px;
            padding-left: 40px;
          }
        }
      }

      .el-checkbox-group {
        height: calc(100% - 96px);
        overflow: auto;
      }

      .search-header {
        line-height: 30px;
        margin: 10px 0;
        font-size: 14px;
        color: #333;
        padding-left: 10px;

        .el-link {
          vertical-align: top;
          line-height: 30px;
          margin-left: 20px;
        }
      }

      &.screen {
        width: 100%;
      }

      .list-footer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 15px 0 0 10px;
      }

      .goods-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        box-sizing: border-box;
      }

      .goods-info {
        display: flex;

        &.active {
          background: #f5f7fa;
        }

        .pic {
          position: relative;
          width: 50px;
          height: 50px;
          border-radius: 4px;

          &::before {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            text-align: center;
            line-height: 50px;
            font-size: 12px;
          }

          &.lower-shelf {
            &::before {
              content: "已下架";
            }
          }

          &.sell-out {
            &::before {
              content: "已售罄";
            }
          }

          &.will-sell-out {
            &::before {
              content: "将售罄";
            }
          }
        }

        .info {
          margin-left: 15px;

          .title {
            font-size: 14px;
            line-height: 28px;
            color: #666666;

            .tag-list {
              display: inline-block;

              &>span {
                background: #ee3030;
                color: #fff;
                font-size: 12px;
                border-radius: 3px;
                padding: 0 5px;
              }
            }
          }

          .price {
            font-size: 14px;
            line-height: 22px;
            color: #ee3030;
          }
        }
      }

      .table-action {
        &>span {
          margin: 0 10px;
        }
      }

      .list-none {
        text-align: center;
        font-size: 14px;
        color: #999999;
        padding-top: 200px;

        &>p {
          margin: 10px 0;
        }
      }
    }
  }
}
</style>
